// src/Components/EditRoom.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NewRoom from './NewRoom';

const EditRoom = () => {
  const { id } = useParams();
  const navigate = useNavigate();
        const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [roomData, setRoomData] = useState(null);

  useEffect(() => {
    const fetchRoom = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/rooms/${id}`);
        if (!res.ok) throw new Error("Failed to fetch room");
        const data = await res.json();
        setRoomData(data);
      } catch (error) {
        console.error("Error fetching room:", error);
        navigate('/rooms');
      }
    };

    fetchRoom();
  }, [id, navigate]);

  return (
    <div>
      {roomData ? (
        <NewRoom editRoomData={roomData} onClose={() => navigate('/rooms')} />
      ) : (
        <p>Loading room...</p>
      )}
    </div>
  );
};

export default EditRoom;
